export default {
  title: 'Salgsoversigt',
  description: 'Salg for den valgte periode – bruges til faktureringsafstemning med denne restaurant.',
  filters: {
    period: 'Periode',
  },
  presets: {
    this_month: 'Denne måned',
    last_month: 'Sidste måned',
    last_30_days: 'Seneste 30 dage',
    this_year: 'I år',
  },
  fields: {
    orders_count: 'Ordrer',
    net_sales: 'Nettosalg',
    sales_tax: 'Moms',
    gross_sales: 'Bruttosalg',
    delivery_fee_tax: 'Leveringsgebyr (moms)',
    delivery_fee_gross: 'Leveringsgebyr (brutto)',
    tips_gross: 'Drikkepenge (brutto)',
    total: 'I alt',
  },
  kpi: {
    before_tax: 'før moms',
    tips: 'indsamlet til restauranten',
    owed_to_restaurant: 'skyldes restauranten',
  },
  table: {
    title: 'Oversigt',
    subtitle: '{{range}} · Alle beløb i {{currency}}',
    field: 'Felt',
    amount: 'Beløb',
    empty: 'Ingen ordrer i den valgte periode',
    footnote:
      'Nettosalg er ekskl. moms; bruttosalg lægger den til igen · I alt er efter platformsgebyrer, så det er ikke det, kunden har betalt · Refusioner og tilbagebetalinger er trukket fra · Beløb i {{currency}}',
  },
  buttons: {
    export_csv: 'Eksportér CSV',
    refresh: 'Opdater',
    retry: 'Prøv igen',
  },
  errors: {
    failed_to_load: {
      title: 'Salgsoversigten kunne ikke indlæses',
      description: 'Noget gik galt under indlæsning af rapporten. Prøv igen.',
    },
  },
};
